import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, TRUCK_SERVICES } from '../utils/constants';
import './FloatingSidebar.css';

const FloatingSidebar: React.FC = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(`Hi! I'm interested in your pickup truck rental services in Dubai. Can you please provide more information?`);
    const whatsappUrl = `https://wa.me/${CONTACT_INFO.phone.replace(/\D/g, '')}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = `tel:${CONTACT_INFO.phone}`;
  };

  return (
    <div className="floating-sidebar">
      {/* Main Services Button */}
      <div className="floating-item main-services" onClick={toggleServices}>
        <i className="fas fa-truck"></i>
        <span className="tooltip">Our Services</span>
      </div>

      {/* Services Dropdown */}
      {isServicesOpen && (
        <div className="services-dropdown">
          <div className="dropdown-header">
            <h4>Our Services</h4>
            <button className="close-btn" onClick={toggleServices}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="services-list">
            {TRUCK_SERVICES.map((service) => (
              <Link 
                key={service.id} 
                to={`/${service.id}-truck`} 
                className="service-link"
                onClick={toggleServices}
              >
                <i className="fas fa-truck"></i>
                <span>{service.title}</span>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <div className="floating-item whatsapp" onClick={handleWhatsAppClick}>
        <i className="fab fa-whatsapp"></i>
        <span className="tooltip">WhatsApp Us</span>
      </div>

      {/* Call Button */}
      <div className="floating-item call" onClick={handleCallClick}>
        <i className="fas fa-phone"></i>
        <span className="tooltip">Call Now</span>
      </div>

      {/* Back to Top Button */}
      <div className="floating-item back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <i className="fas fa-arrow-up"></i>
        <span className="tooltip">Back to Top</span>
      </div>
    </div>
  );
};

export default FloatingSidebar;
